import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { PanelComponent } from './components/panel/panel.component';
import { authGuard } from './_guards/auth.guard';
import { adminGuard } from './_guards/admin.guard';
import { unsavedChangesGuard } from './_guards/unsaved-changes.guard';
import { EmailComponent } from './components/emails/email/email.component';
import { EmailEditorComponent } from './components/emails/email-editor/email-editor.component';
import { PublishedComponent } from './components/published/published.component';
import { AssetsComponent } from './components/assets/assets.component';
import { AdminComponent } from './components/admin/admin.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: PanelComponent,
    children: [
      { path: 'emails', component: EmailComponent },
      { path: 'email-editor/:id', component: EmailEditorComponent, canDeactivate: [unsavedChangesGuard] },
      { path: 'email-templates', component: PublishedComponent },
      { path: 'assets', component: AssetsComponent },
      { path: 'admin', component: AdminComponent, canMatch: [adminGuard] },
      { path: '', redirectTo: 'emails', pathMatch: 'full' },
    ],
    canMatch: [authGuard],
  },
  { path: '**', redirectTo: '' },
];
